import * as React from 'react';
import Svg, {
  SvgProps, Path, Circle,
} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => (
  <Svg
    width={30}
    height={31}
    fill="none"
    {...props}
  >
    <Circle cx={15} cy={10} r={3} fill={props.color ?? '#fff'} />
    <Path
      fill={props.color ?? '#fff'}
      d="M20.991 17.5c0 1.657.5 3-5.991 3-6.49 0-5.991-1.343-5.991-3s2.682-3 5.991-3c3.309 0 5.991 1.343 5.991 3Z"
    />
  </Svg>
);
export default SvgComponent;
